import api from "./client";

export interface CsrOption {
  id: string;
  name: string | null;
  email: string;
}

export const auth = {
  login: (data: any) => api.post("/auth/login", data).then((res) => res.data),
  signup: (data: any) => api.post("/auth/signup", data).then((res) => res.data),
  forgotPassword: (data: any) =>
    api.post("/auth/forgot-password", data).then((res) => res.data),
  resetPassword: (data: any) =>
    api.post("/auth/reset-password", data).then((res) => res.data),
  changePassword: (data: any) =>
    api.post("/auth/change-password", data).then((res) => res.data),
  getProfile: () => api.get("/auth/profile").then((res) => res.data),
  updateProfile: (data: any) =>
    api.patch("/auth/profile", data).then((res) => res.data),
  // Active users of the company, for the CSR dropdown on Profile and on edit user.
  getCsrOptions: (): Promise<CsrOption[]> =>
    api.get("/auth/csr-options").then((res) => res.data),
  // Email changes are OTP-gated and entirely admin-driven: nobody can change
  // their own address, and the admin enters the code the user reads back to
  // them. The address only moves once verifyUserEmailChange succeeds.
  getUserPendingEmailChange: (userId: string) =>
    api.get(`/auth/users/${userId}/email-change`).then((res) => res.data),
  requestUserEmailChange: (userId: string, newEmail: string) =>
    api
      .post(`/auth/users/${userId}/email-change/request`, { newEmail })
      .then((res) => res.data),
  verifyUserEmailChange: (userId: string, code: string) =>
    api
      .post(`/auth/users/${userId}/email-change/verify`, { code })
      .then((res) => res.data),
  resendUserEmailChange: (userId: string) =>
    api
      .post(`/auth/users/${userId}/email-change/resend`)
      .then((res) => res.data),
  cancelUserEmailChange: (userId: string) =>
    api.delete(`/auth/users/${userId}/email-change`).then((res) => res.data),
  getTeamUsers: () => api.get("/auth/users").then((res) => res.data),
  createTeamUser: (data: any) => api.post("/auth/users", data).then((res) => res.data),
  updateTeamUser: (id: string, data: any) => api.patch(`/auth/users/${id}`, data).then((res) => res.data),
  deleteTeamUser: (id: string) => api.delete(`/auth/users/${id}`).then((res) => res.data),
  resendTeamInvitation: (id: string) => api.post(`/auth/users/${id}/resend-invitation`).then((res) => res.data),
};
